module.exports = __webpack_public_path__ + "img/new_41.d4148776.jpg";